/** @jsx jsx */
import { jsx } from '@emotion/core';
import { React } from 'react';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Picture } from '../../ui/Picture';

import * as styles from './index.styles';

import { Container } from '../../../styles/Grid';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import Slider from './Slider';
import Spacer from '../../ui/Spacer';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';

// TODO WHEN IT GOING TO LIVE
const baseImageConfigs = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 327,
    height: 184,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 672,
    height: 376,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 936,
    height: 528,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 1312,
    height: 736,
    gravity: 'auto:subject',
  },
};

class FullWidthImageCarousel extends SafePureComponent {
  renderImages() {
    const CarouselImages = get(this.props, 'fields.CarouselImages', []);
    const preUrl = '';
    return (
      CarouselImages.length &&
      CarouselImages.map((slide, index) => {
        const imageSrc = {
          value: { src: preUrl + slide, alt: 'image - ' + index },
        };
        const imageAlt = slide;

        return (
          <div key={index}>
            <Picture
              image={imageSrc}
              fallbackAlt={imageAlt}
              imageSizes={baseImageConfigs}
              // pictureCss={pictureCss}
              // imageCss={imageCss}
              // isClientLink
              instantLoad
              pictureClassName="swiper-lazy"
            />
          </div>
        );
      })
    );
  }

  safeRender() {
    const Delay = get(this.props, 'fields.Delay', '');
    return (
      <Spacer>
        <Container css={[styles.itemsContainerCss]}>
          <Slider delay={Delay}>{this.renderImages()}</Slider>
        </Container>
      </Spacer>
    );
  }
}

FullWidthImageCarousel.displayName = 'NavBar';

export default withSitecoreContext()(FullWidthImageCarousel);
